module.exports = __webpack_public_path__ + "img/scared.229e2852.jpg";